import { ColliStateName } from '@frontend/colli/types';
import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import React from 'react';

import useColliStateSelect from '././colli-state-select.controller';

const ID = 'colli-state-select';
export interface ColliStateSelectProps extends Omit<SelectInputV2Props<ColliStateName>, 'options'> {
    subset?: string[];
}

export const ColliStateSelect = (props: ColliStateSelectProps) => {
    const viewProps = useColliStateSelect(props);
    return (
        <SelectInputV2<ColliStateName>
            {...props}
            id={ID + props.id}
            label={props.label || 'Colli state'}
            options={viewProps.options}
        />
    );
};
